module.exports = __webpack_public_path__ + "static/media/steps.289cfbbf.png";